import clsx from "clsx";
import * as React from "react";

export const Button = ({
  label = "button",
  disabled = false,
  onClick,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "w-[65vw] max-w-[420px] h-[4.5vh] bg-[#eeeeee] rounded text-gray-800 font-semibold text-[16px]",
        {
          "opacity-50": disabled,
        },
      )}
      disabled={disabled}
      {...props}>
      {label}
    </button>
  );
};
